import React from 'react';
import ContactSection from '../components/ContactSection';

const Contact: React.FC = () => {
  return (
    <div className="pt-20">
      <ContactSection />
    </div>
  );
};

export default Contact;
